import styled from 'styled-components'

export const StyledBarContainer = styled.div`
    background-color: #FDFDFF;
    border: 1px solid #EBEBEB;
    border-radius: 13px;

    .container-top {
        padding: 2rem 1.9rem 1.7rem 2.4rem;
        border-bottom: 1px solid #DFE2E6;
        font-weight: 700;
        font-size: 2rem;
        color: #4F4F4F;
    }
`